// import React from "react";
// import { X } from "lucide-react";
// import { gbp } from "@/lib/api";
// import { allergyWarningFor } from "@/lib/treatmentWarnings";

// export default function TreatmentDetailModal({ treatment: t, onClose, onAdd }) {
//     // Targeted Skin Booster is only sold via its nested NAD+POLY / iLLUMA
//   // options on the catalogue card — hide its own price/deposit/Add to
//   // Cart here so the detail popup can't sell it directly.
//   const hidePriceAndAdd = (t.name || "").trim() === "Targeted Skin Booster";

//   return (
//     <div className="fixed inset-0 z-50 bg-stone-900/30 backdrop-blur-sm" onClick={onClose} data-testid="detail-modal">
//       <div
//         className="absolute right-0 top-0 h-full w-full sm:max-w-xl bg-[#FAF9F6] overflow-y-auto"
//         onClick={(e) => e.stopPropagation()}
//       >
//         <div className="sticky top-0 flex justify-between items-center px-8 py-4 bg-[#FAF9F6]/95 backdrop-blur border-b hairline">
//           <span className="mono-label">Treatment Details</span>
//           <button onClick={onClose} data-testid="close-detail" className="text-stone-500 hover:text-stone-900"><X size={20} /></button>
//         </div>
//         {/* Treatment image intentionally hidden on the individual
//             detail view — image stays visible on the main catalogue /
//             category listing. Everything else on this page (title,
//             price, descriptions, preparation, aftercare, contra-
//             indications, booking button) is unchanged. */}
//         <div className="px-8 py-8">
//           <div className="flex items-center gap-3">
//             <span className="mono-label">{t.category}</span>
//           </div>
//           <h2 className="font-serif text-4xl font-light text-stone-900 mt-4">{t.name}</h2>
//           {allergyWarningFor(t) && (
//             <p className="mt-3 text-[13px] italic text-stone-500" data-testid={`detail-allergy-warning-${t.slug}`}>
//               {allergyWarningFor(t)}
//             </p>
//           )}
//           {!hidePriceAndAdd && (
//             <div className="mt-6 flex items-end justify-between border-b hairline pb-6">
//               <div>
//                 <p className="mono-label">Price</p>
//                 <p className="font-serif text-4xl text-stone-900 mt-1">{gbp(t.price)}</p>
//               </div>
//               {(t.category || "").toLowerCase() !== "consultation" && (t.name || "").toLowerCase() !== "consultation" && (
//                 <div className="text-right">
//                   <p className="mono-label">Deposit</p>
//                   <p className="font-serif text-2xl text-stone-900 mt-1">£{Number(t.deposit_value).toFixed(0)}</p>
//                   <p className="mono-label mt-1">Balance in clinic</p>
//                 </div>
//               )}
//             </div>
//           )}

//           <p className="mt-6 text-stone-700 leading-relaxed">{t.full_description}</p>

//           <div className="mt-8 grid grid-cols-2 gap-4">
//             <Stat label="Duration" value={`${t.duration_min} min`} />
//             <Stat label="Category" value={t.category} />
//           </div>

//           <Section title="What's involved">{t.what_involves}</Section>
//           <Section title="Preparation">{t.preparation}</Section>
//           <Section title="Aftercare">{t.aftercare_summary}</Section>
//           <Section title="Important">{t.important}</Section>
//           <Section title="Contraindications">{t.contraindications}</Section>

//                     {!hidePriceAndAdd && (
//             <button
//               data-testid="detail-add-to-cart"
//               onClick={() => onAdd(t)}
//               className="mt-10 w-full bg-stone-900 text-white py-4 mono-label hover:bg-[#C5A059] transition"
//               style={{ color: "#fff" }}
//             >
//               Add to Cart · {gbp(t.price)}
//             </button>
//           )}

//         </div>
//       </div>
//     </div>
//   );
// }

// const Stat = ({ label, value }) => (
//   <div className="border hairline p-4">
//     <p className="mono-label">{label}</p>
//     <p className="mt-1 font-serif text-lg text-stone-900">{value}</p>
//   </div>
// );

// const Section = ({ title, children }) => (
//   <div className="mt-6 border-t hairline pt-6">
//     <p className="mono-label mb-2">{title}</p>
//     <p className="text-sm text-stone-700 leading-relaxed">{children}</p>
//   </div>
// );
import React from "react";
import { X } from "lucide-react";
import { gbp } from "@/lib/api";
import { allergyWarningFor } from "@/lib/treatmentWarnings";

export default function TreatmentDetailModal({ treatment: t, onClose, onAdd, hidePriceAndAdd = false }) {
  return (
    <div className="fixed inset-0 z-50 bg-stone-900/30 backdrop-blur-sm" onClick={onClose} data-testid="detail-modal">
      <div
        className="absolute right-0 top-0 h-full w-full sm:max-w-xl bg-[#FAF9F6] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 flex justify-between items-center px-8 py-4 bg-[#FAF9F6]/95 backdrop-blur border-b hairline">
          <span className="mono-label">Treatment Details</span>
          <button onClick={onClose} data-testid="close-detail" className="text-stone-500 hover:text-stone-900"><X size={20} /></button>
        </div>
        {/* Treatment image intentionally hidden on the individual
            detail view — image stays visible on the main catalogue /
            category listing. Everything else on this page (title,
            price, descriptions, preparation, aftercare, contra-
            indications, booking button) is unchanged. */}
        <div className="px-8 py-8">
          <div className="flex items-center gap-3">
            <span className="mono-label">{t.category}</span>
          </div>
          <h2 className="font-serif text-4xl font-light text-stone-900 mt-4">{t.name}</h2>
          {allergyWarningFor(t) && (
            <p className="mt-3 text-[13px] italic text-stone-500" data-testid={`detail-allergy-warning-${t.slug}`}>
              {allergyWarningFor(t)}
            </p>
          )}
          {!hidePriceAndAdd && (
            <div className="mt-6 flex items-end justify-between border-b hairline pb-6">
              <div>
                <p className="mono-label">Price</p>
                <p className="font-serif text-4xl text-stone-900 mt-1">{gbp(t.price)}</p>
              </div>
              {(t.category || "").toLowerCase() !== "consultation" && (t.name || "").toLowerCase() !== "consultation" && (
                <div className="text-right">
                  <p className="mono-label">Deposit</p>
                  <p className="font-serif text-2xl text-stone-900 mt-1">£{Number(t.deposit_value).toFixed(0)}</p>
                  <p className="mono-label mt-1">Balance in clinic</p>
                </div>
              )}
            </div>
          )}

          <p className="mt-6 text-stone-700 leading-relaxed">{t.full_description}</p>

          <div className="mt-8 grid grid-cols-2 gap-4">
            <Stat label="Duration" value={`${t.duration_min} min`} />
            <Stat label="Category" value={t.category} />
          </div>

          <Section title="What's involved">{t.what_involves}</Section>
          <Section title="Preparation">{t.preparation}</Section>
          <Section title="Aftercare">{t.aftercare_summary}</Section>
          <Section title="Important">{t.important}</Section>
          <Section title="Contraindications">{t.contraindications}</Section>

          {!hidePriceAndAdd && (
            <button
              data-testid="detail-add-to-cart"
              onClick={() => onAdd(t)}
              className="mt-10 w-full bg-stone-900 text-white py-4 mono-label hover:bg-[#C5A059] transition"
              style={{ color: "#fff" }}
            >
              Add to Cart · {gbp(t.price)}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

const Stat = ({ label, value }) => (
  <div className="border hairline p-4">
    <p className="mono-label">{label}</p>
    <p className="mt-1 font-serif text-lg text-stone-900">{value}</p>
  </div>
);

const Section = ({ title, children }) => (
  <div className="mt-6 border-t hairline pt-6">
    <p className="mono-label mb-2">{title}</p>
    <p className="text-sm text-stone-700 leading-relaxed">{children}</p>
  </div>
);
